import { render, staticRenderFns } from "./AbonosTab.vue?vue&type=template&id=d2d5039c"
import script from "./AbonosTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AbonosTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports